module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0119.jpg?v=3422bf9e";